<template>
  <section>
    <div class="workarea">
      <div class="ui-wood-block-chiseling" :class="{'animate': isAnimate }"></div>
      <div class="tool tool--small-chisel" :class="{'animate': isAnimate }"></div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'scene5animation',
  data: function () {
    return {
      isAnimate: false,
    }
  },
  methods: {
    animate() {
      this.isAnimate = !this.isAnimate;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style";

.workarea {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  width: fluid(256px);
  height: fluid(251px);

  // preload images (https://stackoverflow.com/questions/1373142/preloading-css-images)
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
    content: url('~@/assets/img/wood-block--chisel--after.svg')
      url('~@/assets/img/wood-block--chisel--after.svg')
      url('~@/assets/img/wood-block--refine--step1.svg')
      url('~@/assets/img/wood-block--refine--step2.svg');
  }
}

.tool--small-chisel {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  &.animate {
    animation-name: small-chisel;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

.ui-wood-block-chiseling {
  background-image: none;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: center center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/img/wood-block--chisel--after.svg');

  &.animate {
    animation-name: refine-wood;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

@keyframes small-chisel {
  0% { opacity: 1; }
  25% { top: 5%; left: 80%; opacity: 1; }
  50% { top: 25%; left: 10%; opacity: 1; }
  75% { top: 35%; left: 45%; opacity: 1; }
  100% { top: 50%; left: 50%; opacity: 0; }
}

@keyframes refine-wood {
  0% { background-image: url('~@/assets/img/wood-block--chisel--after.svg') }
  25% { background-image: url('~@/assets/img/wood-block--chisel--after.svg') }
  
  49% { background-image: url('~@/assets/img/wood-block--refine--step1.svg') }
  50% { background-image: url('~@/assets/img/wood-block--refine--step1.svg') }
  75% { background-image: url('~@/assets/img/wood-block--refine--step1.svg') }

  99% { background-image: url('~@/assets/img/wood-block--refine--step2.svg') }
  100% { background-image: url('~@/assets/img/wood-block--refine--step2.svg') }

  // 100% { background-image: url('~@/assets/img/wood-block--finished.svg') }
}

</style>
